<template>
	<div class="send-receipt-sheet">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="ordersStore.sendReceiptEpsonData !== null" :z-index="1002" @toggling-popup="toggleBottomSheet">
			<div class="delivery-info-sheet-content" v-if="ordersStore.sendReceiptEpsonData">
				<ModalHeader :title="getString('epson_receipt')"></ModalHeader>
				<AppList v-if="receiptData && receiptData.receipt_number" :items="sendItems" />
				<div class="row centered" v-else>
					<AppLoader />
				</div>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import {useEpsonStore, useOrdersStore, useAblyStore, usePrintersStore, useUserStore} from "@/console-new/stores";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import AppList from "@/shared/components/AppList.vue";
import {useCurrencyStore, useLanguageStore, useNotificationStore} from "@/shared/stores";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import AppButton from "@/shared/components/AppButton.vue";
import API from "@/shared/helpers/API";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppQrImage from "@/shared/components/AppQrImage.vue";
import {getNative, isNative} from "@/shared/helpers/webapp";
import AppLoader from "@/shared/components/AppLoader.vue";

export default {
	components: {AppLoader, AppQrImage, AppTextInput, AppChevronIcon, AppButton, ModalHeader, AppList, AppBottomSheet},
	setup() {
		const ordersStore = useOrdersStore();
		const languageStore = useLanguageStore();
		const printersStore = usePrintersStore();
		const epsonStore = useEpsonStore();
		const userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		const notificationStore = useNotificationStore();
		return {
			currencyStore,
			userStore,
			printersStore,
			ordersStore,
			epsonStore,
			notificationStore,
			getString: languageStore.getString,
		}
	},
	mixins: [WindowWidth],
	name: "SendReceiptEpsonSheet",
	data() {
		return {
			loadingPrint: false,
			receiptData: null,
		}
	},
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		sendItems() {
			let items = [{
				title: this.getString("reprint_receipt"),
				buttonTitle: this.getString("print"),
				callbackButton: () => {
					this.printReceipt();
				},
				buttonLoading: this.loadingPrint,
			}];
			if(this.receiptData && this.receiptData.refunded === 0) {
				items = items.concat([{
					title: this.getString("refund_receipt"),
					buttonTitle: this.getString("refund"),
					callbackButton: () => {
						this.refundReceipt();
					},
					buttonLoading: this.loadingPrint,
				}, {
					title: this.getString("cancel_receipt"),
					buttonTitle: this.getString("cancel"),
					callbackButton: () => {
						this.cancelReceipt();
					},
					buttonLoading: this.loadingPrint,
				}]);
			} else {
				items.push({
					title: this.getString("receipt_already_refunded"),
				});
			}
			return items;
		},
	},
	methods: {
		toggleBottomSheet(open) {
			if(!open) {
				this.ordersStore.sendReceiptEpsonData = null;
			}
		},
		printReceipt() {
			if(isNative()) {
				let day = this.receiptData.date.getDate();
				let month = this.receiptData.date.getMonth() + 1;
				let year = this.receiptData.date.getFullYear();
				this.loadingPrint = true;
				getNative().reprintReceipt(day+"", month+"", year+"", this.receiptData.receipt_number+"").then((r) => {
					this.notificationStore.showNotification("generic-success");
					this.loadingPrint = false;
				});
			}
		},
		refundReceipt() {
			if(isNative()) {

				getNative().refundReceipt(this.getRefundData()).then((r) => {
					this.notificationStore.showNotification("generic-success");
					this.loadingPrint = false;

					API.init().setReceiptRefunded(this.userStore.currBusinessId, this.ordersStore.sendReceiptEpsonData.epson_receipt_id, 1, (response) => {

						this.receiptData.refunded = 1;
					});
				});
			}
		},
		cancelReceipt() {
			if(isNative()) {

				getNative().refundReceipt(this.getRefundData("cancel")).then((r) => {
					this.notificationStore.showNotification("generic-success");
					this.loadingPrint = false;

					API.init().setReceiptRefunded(this.userStore.currBusinessId, this.ordersStore.sendReceiptEpsonData.epson_receipt_id, 2, (response) => {

						this.receiptData.refunded = 2;
					});
				});
			}
		},
		getRefundData(type = "refund") {
			let day = this.receiptData.date.getDate();
			if(day < 10) {
				day = "0" + day;
			}
			day = day + "";
			let month = this.receiptData.date.getMonth() + 1;
			if(month < 10) {
				month = "0" + month;
			}
			month = month + "";
			let year = this.receiptData.date.getFullYear();
			let date = day + month + year;


			let number = this.receiptData.receipt_number.toString();
			while(number.length < 4) {
				number = "0" + number;
			}

			let zrep = this.receiptData.zrep.toString();
			while(zrep.length < 4) {
				zrep = "0" + zrep;
			}

			let total =  this.epsonStore.formatPriceString(this.receiptData.total);

			let paymentInfo = this.epsonStore.getEpsonPaymentInfoFromType(this.ordersStore.sendReceiptEpsonData.type);

			let refType = type === "refund" ? "REFUND" : "VOID";
			let descType = type === "refund" ? "Rimborso" : "Annullamento";

			this.loadingPrint = true;

			return '<printRecMessage operator="1" Text="'+refType+' ' + zrep + ' ' + number + ' ' + date + ' POS" Type="4" Index="1" Font="4" />' +
				'<printRecRefund operator="1" Text="'+descType+'" Qty="1" UnitCost="' + total + '" Dep="1" Just="1" />' +
				'<printRecTotal operator="1" description="' + paymentInfo.paymentDesc + '" payment="' + total + '" paymentType="' + paymentInfo.paymentMode + '" index="3" justification="1" />';
		}
	},
	watch: {
		'ordersStore.sendReceiptEpsonData': function() {
			if(this.ordersStore.sendReceiptEpsonData && this.ordersStore.sendReceiptEpsonData.epson_receipt_id) {
				this.receiptData = null;
				API.init().getEpsonReceiptData(this.userStore.currBusinessId, this.ordersStore.sendReceiptEpsonData.epson_receipt_id, (r) => {
					if(r.result && r.result === "OK") {
						this.receiptData = {
							...r.data,
							refunded: Number(r.data.refunded),
							date: new Date(r.data.date),
							total: Number(r.data.total),
						};
					} else {
						this.notificationStore.showNotification("generic-fail");
					}
					this.loadingPrint = false;
				});
			}
		}
	}
}
</script>

<style scoped lang="scss">

.send-receipt-sheet {

	.double-text-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;

		.title {
			font-size: 14px;
			color: #9b9b9b;
		}

		.value {
			font-size: 16px;
			color: $primary;
			margin-left: auto;
			text-align: right;
		}

	}

}


.row-clickable {
	cursor: pointer;

	.chevron-container {
		height: 35px;
		display: flex;
		align-items: center;
	}
}

.email-container {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: center;
	width: 100%;

}

.qr-container {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: center;
	width: 100%;

}
</style>